import { useState, Fragment } from "react";
import { _t } from "core/language";
import GroupAction from "core/components/GroupAction";
import { Button, ButtonConfirm } from "core/components/form-controls";
import { CoupangDesciption } from "core/components/Coupang";
import { type IRecipeDetail } from './../../store/types'
import RecipeIngredientsLoading from './Loading'
import { useMyIngredient } from "modules/Ingredients/hooks/myIngredient";

const EXPANDED_LIMIT = 5;

const RecipeIngredients = ({recipe, loading}: {recipe: IRecipeDetail, loading: boolean}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const {
    addToMyIngredients,
    onRemoveMyIngredients,
    checkExist,
  } = useMyIngredient()

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const handleClickIcon = (type: any, data:any) => {
    console.log(type, data);
    
  }

  const visibleItems = isExpanded
    ? recipe.content?.ingredient
    : (recipe.content?.ingredient || []).slice(0, EXPANDED_LIMIT);
  const expandedItems = recipe.content?.ingredient?.length - EXPANDED_LIMIT > 0
    ? recipe.content?.ingredient?.length - EXPANDED_LIMIT
    : 0

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <label
          className="text-dark font-medium text-base max-w-50"
          dangerouslySetInnerHTML={{ __html: _t('recipe.ingredients.title') }}
        />
        <ButtonConfirm
          label={_t('recipe.ingredients.add_all')}
          size="sm"
          className="max-w-50 min-w-[119px]"
          classBtn="px-2.5 w-full font-medium tracking-tighter !py-[6.5px] tracking-tighter	"
          message={_t('recipe.msg.msg_4')}
          handleSubmit={() => addToMyIngredients(recipe.content?.ingredient)}
          submitText={_t('recipe.msg.confirm')}
          closeText={_t('recipe.msg.cancel')}
          showWithAuth
        />
      </div>
      {loading ? (
        <nav className="flex flex-col text-sm font-medium gap-2.5 mb-5">
          {Array.from(Array(EXPANDED_LIMIT).keys()).map((e: number) =>
            <RecipeIngredientsLoading key={e} />
          )}
        </nav>
      ) : (
        <Fragment>
          <nav className="flex flex-col text-sm font-medium gap-2.5 mb-5">
            {visibleItems?.map((ingredient: any, key: number) => (
              <div className={`flex justify-between items-center h-[34px] ${ingredient?.id ? ingredient?.id : ' hidden'}`} key={key}>
                <label className={`text-sm ${checkExist(ingredient) ? 'text-primary' : ''}`}>
                  {ingredient.name} {ingredient.qty}
                </label>
                <div className="min-w-[118px]">
                  <GroupAction
                    ingredient={ingredient}
                    ingredient_id={ingredient.id}
                    handleClickIcon={(e) => handleClickIcon(e, ingredient)}
                  />
                </div>
              </div>
            ))}
          </nav>
          <CoupangDesciption className="mb-5" />
          <div className="flex gap-2 w-full">
            {expandedItems ? <Button
              label={
                !isExpanded
                  ? `${_t('recipe.ingredients.view_more', {number: expandedItems})}`
                  : _t('recipe.ingredients.view_less')
              }
              classBtn="w-full h-full font-medium tracking-tighter"
              onClickBtn={toggleExpanded}
            /> : null}
            <ButtonConfirm
              label={_t('recipe.ingredients.delete_all')}
              className={`w-full ${expandedItems ? 'max-w-50' : ''}`}
              classBtn="w-full h-full font-medium tracking-tighter"
              message={_t('recipe.msg.msg_2')}
              handleSubmit={() => onRemoveMyIngredients(recipe.content?.ingredient)}
              submitText={_t('recipe.msg.confirm')}
              closeText={_t('recipe.msg.cancel')}
              showWithAuth
            />
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default RecipeIngredients
